<script lang="ts">
  // The always-visible impersonation signal (wiki/feature-impersonation.md
  // AC13.1–AC13.3). A LAYOUT banner: it occupies real space at the top of the
  // root layout and pushes nav, page content and the focus-mode shell down by
  // its own height — never fixed, never absolute, never overlaying.
  //
  // One line only: "Acting as {display name}" + Stop. The email and the reason
  // belong to the account menu's identity block, which is the single place they
  // appear. Data source is the auth store — never the cookie, which is HttpOnly.
  // `$auth.user` IS the target (the whoami body is the effective account);
  // `$auth.user.impersonation` names the admin.

  import { auth } from '$lib/stores/auth';
  import { displayName } from '$lib/utils/formatting/displayName';
  import ImpersonationStopButton from '$lib/ui/nav/ImpersonationStopButton.svelte';
  import { t } from '$lib/i18n';
  import { UiKeys } from '@voicedojo/backend-types';
</script>

{#if $auth.status === 'authenticated' && $auth.user.impersonation}
  <div class="impersonation-banner no-print" role="alert" aria-live="polite">
    <div class="message">
      <span aria-hidden="true" class="icon">!</span>
      <span>{t(UiKeys.Impersonation.ActingAs, { Name: displayName($auth.user) })}</span>
    </div>
    <ImpersonationStopButton />
  </div>
{/if}

<style lang="scss">
  .impersonation-banner {
    width: 100%;
    box-sizing: border-box;
    background: var(--paper);
    color: var(--ink);
    border-bottom: 2px solid var(--color-marigold);
    padding: 0.75rem 1rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    font-family: var(--font-ui);
    font-size: var(--text-body);
  }

  .message {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 1 1 14rem;
    min-width: 0;
  }

  .icon {
    display: inline-flex;
    width: 1.5rem;
    height: 1.5rem;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: var(--color-marigold);
    color: var(--on-fill);
    font-weight: 700;
    flex: 0 0 auto;
  }
</style>
